export default __webpack_public_path__ + "static/media/correct3.59e9b288.mp3";